import { Utils } from '@/utils/Utils'

/**
 * LOGISPRD-12495 — BE 공통 화주 범위 가드가 `meta.errorCode` 에 싣는 코드.
 * 막힌 화주코드·주문번호는 응답에 없으므로 화면은 "권한 없음" 까지만 안내할 수 있다.
 * FORBIDDEN(403) 은 멤버십 3종이 아니라서 request 인터셉터가 로그아웃하지 않고 호출부로 reject 한다.
 */
export const SHIPPER_SCOPE_ERROR_CODE = {
  FORBIDDEN: 'SHIPPER_SCOPE_FORBIDDEN',
  UNAVAILABLE: 'SHIPPER_SCOPE_UNAVAILABLE',
} as const

export const SHIPPER_SCOPE_FORBIDDEN_MESSAGE = '선택한 화주의 출고일정을 변경할 권한이 없습니다.'

// 허용 화주 조회 자체가 실패한 500 — 권한 문제가 아니므로 재시도를 안내한다.
export const SHIPPER_SCOPE_UNAVAILABLE_MESSAGE = '일시적인 오류로 요청을 처리하지 못했습니다. 잠시 후 다시 시도해 주세요.'

/** 화주 범위 거부면 안내 문구, 무관한 에러면 undefined — 호출부는 기존 실패 문구로 이어 쓴다 */
export const getShipperScopeErrorMessage = (e: unknown, forbiddenMessage: string = SHIPPER_SCOPE_FORBIDDEN_MESSAGE): string | undefined => {
  switch (Utils.getApiErrorCode(e)) {
    case SHIPPER_SCOPE_ERROR_CODE.FORBIDDEN:
      return forbiddenMessage
    case SHIPPER_SCOPE_ERROR_CODE.UNAVAILABLE:
      return SHIPPER_SCOPE_UNAVAILABLE_MESSAGE
    default:
      return undefined
  }
}
